module.exports = require('./_hide');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/_redefine.js
 ** module id = 457
 ** module chunks = 0
 **/